export const ADMIN_ROLES = {
  ADMIN: 'admin',
  EXERCISE_EDITOR: 'exercise_editor',
};

export const ADMIN_ROLE_LABELS = {
  [ADMIN_ROLES.ADMIN]: 'Administrateur',
  [ADMIN_ROLES.EXERCISE_EDITOR]: 'Éditeur d\'exercices',
};

export function hasAdminPanelAccess(adminRole) {
  return adminRole === ADMIN_ROLES.ADMIN || adminRole === ADMIN_ROLES.EXERCISE_EDITOR;
}

export function isFullAdmin(adminRole) {
  return adminRole === ADMIN_ROLES.ADMIN;
}

export function isExerciseEditor(adminRole) {
  return adminRole === ADMIN_ROLES.EXERCISE_EDITOR;
}

/** Routes frontend autorisées pour exercise_editor */
export function canAccessAdminRoute(pathname, adminRole) {
  if (isFullAdmin(adminRole)) return true;
  if (!isExerciseEditor(adminRole)) return false;

  const editorPaths = [
    '/admin/exercises',
    '/admin/exercise-taxonomy',
    '/admin/adventures',
    '/admin/scenarios',
  ];
  return editorPaths.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

/** Entrées de navigation visibles selon le rôle */
export function getVisibleNavItems(adminRole) {
  const allItems = [
    { key: 'dashboard', path: '/admin', fullAdminOnly: true },
    { key: 'exercises', path: '/admin/exercises', fullAdminOnly: false },
    { key: 'exercise-taxonomy', path: '/admin/exercise-taxonomy', fullAdminOnly: false },
    { key: 'users', path: '/admin/users', fullAdminOnly: true },
    // File de revue des signalements — exigence des stores pour tout UGC, et
    // réservée à l'admin complet : on y lit du contenu écrit par des enfants.
    { key: 'signalements', path: '/admin/signalements', fullAdminOnly: true },
    { key: 'stats', path: '/admin/stats', fullAdminOnly: true },
    { key: 'consommation-ia', path: '/admin/consommation-ia', fullAdminOnly: true },
    { key: 'entonnoir-achat', path: '/admin/entonnoir-achat', fullAdminOnly: true },
    { key: 'prompt-engineering', path: '/admin/prompt-engineering', fullAdminOnly: true },
    { key: 'marketing', path: '/admin/marketing', fullAdminOnly: true },
    { key: 'teacher-pages', path: '/admin/teacher-pages', fullAdminOnly: true },
    { key: 'etablissements', path: '/admin/etablissements', fullAdminOnly: true },
    { key: 'scenarios', path: '/admin/scenarios', fullAdminOnly: false },
    { key: 'adventures', path: '/admin/adventures', fullAdminOnly: false },
    { key: 'products-audit', path: '/admin/products-audit', fullAdminOnly: true },
    { key: 'grimoire', path: '/admin/grimoire', fullAdminOnly: true },
    { key: 'impressions', path: '/admin/impressions', fullAdminOnly: true },
    { key: 'offres-du-moment', path: '/admin/offres-du-moment', fullAdminOnly: true },
    { key: 'catalog-items', path: '/admin/catalog-items', fullAdminOnly: true },
    { key: 'parent-feedbacks', path: '/admin/parent-feedbacks', fullAdminOnly: true },
    { key: 'serving-gaps', path: '/admin/serving-gaps', fullAdminOnly: true },
    { key: 'notions-demandees', path: '/admin/notions-demandees', fullAdminOnly: true },
    { key: 'taxonomy-referential', path: '/admin/taxonomy-referential', fullAdminOnly: true },
    { key: 'error-classification', path: '/admin/error-classification', fullAdminOnly: true },
  ];

  if (isFullAdmin(adminRole)) return allItems;
  return allItems.filter((item) => !item.fullAdminOnly);
}
